export type NotificationHookType =
  | "webhook"
  | "amazon_sns"
  | "amazon_sqs"
  | "slack"
  | "pagerduty"
  | "email"
  | "microsoft_teams"
  | "google_pubsub";

export interface NotificationHook {
  type: NotificationHookType;
  endpoint: string;
  enabled: boolean;
}

export type NotificationTrigger =
  | "issued"
  | "expiring"
  | "expired"
  | "revoked"
  | "renewed";

export interface Notification {
  id: string;
  name: string;
  trigger: NotificationTrigger;
  hooks: NotificationHook[];
  createdAt: string;
  enabled: boolean;
}

export const NOTIFICATION_TRIGGERS: NotificationTrigger[] = [
  "issued",
  "expiring",
  "expired",
  "revoked",
  "renewed",
];

export const HOOK_TYPES: { value: NotificationHookType; label: string }[] = [
  { value: "webhook", label: "Webhook" },
  { value: "amazon_sns", label: "Amazon SNS" },
  { value: "amazon_sqs", label: "Amazon SQS" },
  { value: "slack", label: "Slack" },
  { value: "pagerduty", label: "PagerDuty" },
  { value: "email", label: "Email" },
  { value: "microsoft_teams", label: "Microsoft Teams" },
  { value: "google_pubsub", label: "Google Pub/Sub" },
];
